import {
    SET_COMMON_ERROR,
} from "./CommonErrorHandlerType"

const setCommonAPIError = (commonApiError : any) => ({
    type: SET_COMMON_ERROR,
    commonApiError
});

export {
    setCommonAPIError
}
